import { useCallback } from 'react';
import { isEmpty } from 'lodash';
import { useGetMeasurementDatesByFund } from 'services/hooks/funds';
import { UseGetMeasurementDates } from './types';
import { CompanyMeasurementDate, MeasurementDateRolloverReturn } from '../../../../api';

const useGetMeasurementDates: UseGetMeasurementDates = params => {
  const { activeFund, setSelectedMeasurementDate, openMeasurementDatesDialog } = params;

  const { data: measurementDates, refetch } = useGetMeasurementDatesByFund({
    fund: activeFund,
    shouldQueryAutomatically: !openMeasurementDatesDialog,
  });

  const getMeasurementDates = useCallback(
    async (newMeasurementDates: MeasurementDateRolloverReturn[]) => {
      await refetch();

      if (isEmpty(newMeasurementDates)) {
        return;
      }

      const filteredMDs = newMeasurementDates.filter(md => md.company_mds);
      const flatCompanyMds = filteredMDs.flatMap(md => md.company_mds) as CompanyMeasurementDate[];

      const recentMD = flatCompanyMds?.[0]?.measurement_date;

      if (!isEmpty(recentMD)) {
        setSelectedMeasurementDate(recentMD);
      }
    },
    [refetch, setSelectedMeasurementDate]
  );

  return {
    getMeasurementDates,
    measurementDates,
  };
};

export default useGetMeasurementDates;
